import React from 'react';
import './index.css';
import clsx from 'classnames';

const Demand = () => {
  const demandList = [
    {
      name: '领导风险监控',
      textList: [
        '业务数量多吗？',
        '检测员工作量饱和吗？',
        '检测准确率高吗？',
        '能按时交付检测报告吗？',
        '新的客户有哪些？',
      ],
    },
    {
      name: '运营分析改善',
      textList: [
        '客户提出需求是否已上线？',
        '发现的问题是否全部修复？',
        '原始记录单和报告模版是否合理？',
        '检测标准依据和样品对应吗？',
        '系统界面是否美观、清晰易懂？',
      ],
    },
    {
      name: '检测操作便捷',
      textList: [
        '每天的工作任务是什么？',
        '样品的检测标准有哪些？',
        '检测任务要在什么时间内完成？',
        '数据录入时是否符合标准的规则？',
        '哪些是我需要优先处理的任务？',
      ],
    },
    {
      name: 'IT运维及拓展',
      textList: [
        '集成性--接口是否完善',
        '拓展性--功能是否完备/升级是否方便？',
        '便捷性--运维是否便捷？',
        '系统是否稳定？',
        'BUG多吗？',
      ],
    },
  ];

  return (
    <div className={clsx('intelligence-demand')}>
      <div className={clsx('intelligence-demand-title')}>
        数智化满足用户需求
      </div>
      <div className={clsx('intelligence-demand-text')}>
        专注/诚信/品质/创新
      </div>
      <div className={clsx('intelligence-demand-content')}>
        {demandList.map((item, index) => (
          <div key={index} className={clsx('intelligence-demand-content-item')}>
            <div className={clsx('intelligence-demand-content-item-top')}>
              <div
                className={clsx('intelligence-demand-content-item-top-name')}
              >
                {item.name}
              </div>
            </div>
            <div className={clsx('intelligence-demand-content-item-list')}>
              {item.textList?.map((v, key) => {
                return (
                  <div
                    className={clsx(
                      'intelligence-demand-content-item-list-item',
                    )}
                    key={key}
                  >
                    {v}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Demand;
